import { Select } from '@mantine/core'
import { useNavigate } from 'react-router-dom'
import BaseButton from '../../components/common/BaseButton'
import '../../styles/admin/billing-box.css'
import List from '../common/List'
import { Modal, Pagination } from '@mantine/core'
import { useState,useEffect } from 'react'
import { useAuthStore } from '../../store'
import { apiRequest } from '../../utils/api'
import { notifications } from '@mantine/notifications'
import styles from '../../styles/admin/CenterCard.module.scss'


const BillingBox = () => {
  const { user } = useAuthStore()

  const [billingData,setBillingData] = useState([])
  const [updateId, setUpdateId] = useState(0)
  const [canType, setCanType] = useState(0)

  useEffect(() => {
    selectPaymentList()
  },[])

    const selectPaymentList = async () => {
        const res = await apiRequest('/getSubscribeUserData', 'POST', { USER_ID: user.USER_ID })
        if(res.data) {
            const filteredData = res.data.map((v, index) => {
                if(index == 0) {
                    setUpdateId(v.ID)
                    setCanType(v.SUB_CAN_TYPE)
                }
                  const baseData = {
                    //PaymentID: index + 1,
                    Subscribe: v.ITEM_NM,
                    Amount: v.TOTAL_PRICE,
                    Start_date: v.START_DATE,
                    End_date: v.END_DATE ? v.END_DATE : '-',
                    Subscribe_date: v.SUB_START_DATE ? v.SUB_START_DATE : '-',
                    Status: v.SUB_CAN_TYPE_NM,
                    }
                  // 매니저인 경우 기본 데이터만 반환
                  return baseData;
                })
                setBillingData(filteredData)
        }

    }



  const invoiceColumnWidths = ['20%', '10%', '10%', '20%', '20%', '20%']
  const headers = [
    'Subscribe',
    'Amount',
    'Start_date',
    'End_date',
    'Subscribe_date',
    'Status',
  ]
  const [monthlyModalOpen, setMonthlyModalOpen] = useState(false)
  const [yearlyModalOpen, setYearlyModalOpen] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)

  const handleMonthlyModalOpen = () => {
    setMonthlyModalOpen(true)
  }

  const handleYearlyModalOpen = () => {
    setYearlyModalOpen(true)
  }

  const handlePageChange = (page) => {
    setCurrentPage(page)
  }

  const handleItemsPerPageChange = (value) => {
    const numValue = parseInt(value.replace('개', ''))
    setItemsPerPage(numValue)
    setCurrentPage(1)
  }

  const getCurrentPageData = () => {
    const data = billingData || []
    const startIndex = (currentPage - 1) * itemsPerPage
    const endIndex = startIndex + itemsPerPage
    return data.slice(startIndex, endIndex)
  }
  const totalPages = Math.ceil((billingData?.length || 0) / itemsPerPage)
  const currentData = getCurrentPageData()

  const handleCancel = async() => {

    //구독 취소 기능 -> 첫번째 구독 내용이 구독 중 일때만 실행 과거꺼는 이미 끝났기 떄문에
      if(canType == "") { //초기상태
           const res = await apiRequest('/updateOrderCancel', 'POST', {
              id : updateId
           })
         notifications.show({
           title: 'Success',
           message: 'Subscribe cancellation application completed',
           color: 'green',
         })

        selectPaymentList()
      } else if(canType == "I") { //취소중
          notifications.show({
            title: 'Error',
            message: 'Canceling subscription',

            color: 'red',
          })
      } else if(canType == "C") { //취소완료
          notifications.show({
            title: 'Error',
            message: 'Your Subscribe has been canceled',
            color: 'red',
          })
      }  else if(canType == "R") { //취소완료
          notifications.show({
            title: 'Error',
            message: 'I was rejected.',
            color: 'red',
          })
      }

  }

  return (
    <div>
      <div className="uploads-search-section">

        <div className="search-section">
            {/*
          <Select
            styles={{ input: { width: '100px', height: '30px' } }}
            data={[
              { value: 'latest', label: 'Newest' },
              { value: 'oldest', label: 'Oldest' },
            ]}
            defaultValue="latest"
            placeholder="Sort"
            onChange={(value) => {}}
          />
          */}
        </div>

        <div className="search-buttons">
          <BaseButton
            className="billing-box-button"
            onClick={handleCancel}
          >
            Cancel Subscribe
          </BaseButton>
          {/*
          <BaseButton
            className="billing-box-button"
            onClick={handleYearlyModalOpen}
          >
            Annual payment
          </BaseButton>
          */}
        </div>
      </div>

      <List
        showCheckbox={false}
        headers={headers}
        data={currentData}
        columnWidths={invoiceColumnWidths}
      />

      <div className={styles.paginationWrapper}>
        <Pagination
          value={currentPage}
          onChange={handlePageChange}
          total={totalPages}
          size="sm"
          withEdges={false}
          color="gray"
          classNames={{
            control: styles.paginationControl,
          }}
        />
      </div>

      <div className="users-select-wrapper">
        <Select
          styles={{ input: { width: '150px', height: '40px' } }}
          data={['10entries', '20entries', '50entries']}
          value={`${itemsPerPage}entries`}
          onChange={handleItemsPerPageChange}
        />
      </div>

      {/* 월결제 */}
      <Modal
        opened={monthlyModalOpen}
        onClose={() => setMonthlyModalOpen(false)}
        centered
      >
        <div>페이팔 연결</div>
      </Modal>

      {/* 년결제 */}
      <Modal
        opened={yearlyModalOpen}
        onClose={() => setYearlyModalOpen(false)}
        centered
      >
        <div>페이팔 연결</div>
      </Modal>
    </div>
  )
}

export default BillingBox
